// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--3d_qgXAlj","changed":"changed--RQvIlTnuw"};